var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"btn",on:{"click":function($event){return _vm.$emit('click')}}},[_c('font-awesome-icon',{staticClass:"mr-2",attrs:{"icon":"arrow-left"}}),_vm._v(_vm._s(_vm.$t("actions.zurueck"))+" ")],1)
}
var staticRenderFns = []

export { render, staticRenderFns }